<template>
    <div class="common-chart-block">
    <div :id="myChartId" class="chart-box"> </div>
    </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
    import echarts from 'echarts'
    export default {
        props: {
           chartName:{type:String,default:''},
           options:{type:Object,default:function(){ return {}}},
         
        },
        data() {
            return {
                   myCharts :null,
            }
        },
        computed:{
            myChartId(){
                return 'charts_'+ this.chartName;
            }
        },
        mounted() {
            
            this.myCharts = echarts.init(document.getElementById('charts_'+ this.chartName));
 
            this.myCharts.setOption(this.options);
            //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
            window.addEventListener('resize', function() {
                if(this.myCharts){
                    this.myCharts.resize();
                }
               
            });
        },
        methods: {},
        watch: {
options: {
   immediate: true, // 很重要！！！
   deep:true,
   handler (val,old) {
      
              if(this.myCharts){
                 
                    this.myCharts.setOption(val);
                }
   }
},
            
          
        },
        created() {}
    }
</script>
 